module.exports = __webpack_public_path__ + "83eb94e1d445704ad6f56867df395ea5.svg";